



























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import OverUseDto from "@/store/entities/Common/ReplaceDeviceDto";

@Component({
  components: {},
})
export default class DeleteWaringMessage extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  orgdeivetdto: OverUseDto = new OverUseDto();
  loading: boolean = false;
  checktype: number = 4;
  create() { }
  created() {
    this.checktype = 4;
  }
  changeRadio(val) {
    this.checktype = val;
  }
  async save() {
    this.loading = true;
    let res = await this.$store
      .dispatch({
        type: "waringmessage/deletebatch",
        data: this.checktype,
      })
      .catch((err) => {
        this.loading = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
    this.$Modal.info({
      title: this.L("Tips"),
      content: res.data.result,
    });
    this.loading = false;
    (this.$refs.itemForm as any).resetFields();
    this.$emit("save-success");
    this.$emit("input", false);
  }
  cancel() {
    (this.$refs.itemForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
}
